import { RouteObject } from 'react-router';
import { SchoolCourseDetailsNoStudentSelected, StudentDetails } from '../components';

export const SchoolCourseSectionStudentRoutes: RouteObject[] = [
  { path: 's/:studentId', element: <StudentDetails /> },
  { path: '', element: <SchoolCourseDetailsNoStudentSelected /> }
];
